import { LoadableAfterPaint } from '@confluence/loadable';

export const ShareFeedbackButtonLoader = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-LazyFeedbackCollector" */ './ShareFeedbackButton'))
			.ShareFeedbackButton,
});
